import { render, staticRenderFns } from "./HeirForm.vue?vue&type=template&id=d6a4974a&"
import script from "./HeirForm.vue?vue&type=script&lang=js&"
export * from "./HeirForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports